<template>
  <div class="login-page">
    <TheAppBar />

    <v-content class="login-page__content" transition="out-in">
      <v-container fill-height>
        <v-row>
          <v-col class="text-center">
            <login-form source="client" redirect-name="projects">
              <template #no-account>
                No account? Join Bench as a
                <router-link
                  :to="{ name: 'register' }" class="login-page__register"> company</router-link>
              </template>
            </login-form>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </div>
</template>

<script>
import TheAppBar from '@/components/TheAppBar.vue';
import LoginForm from '@/components/LoginForm.vue';

export default {
  metaInfo: {
    title: 'Login',
  },

  components: {
    TheAppBar,
    LoginForm,
  },
};
</script>

<style lang="scss" scoped>
.login-page {
  background: #FCFCFC;
  &__content {
    min-height: calc(100vh - 64px);
  }

  &__register {
    color: $color--blue !important;
  }
}
</style>
